"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagesType = exports.CameraAccessStatus = void 0;
var CameraAccessStatus;
(function (CameraAccessStatus) {
    CameraAccessStatus["ACCEPTED"] = "ACCEPTED";
    CameraAccessStatus["REJECTED"] = "REJECTED";
    CameraAccessStatus["PERMANENT_REJECTED"] = "PERMANENT_REJECTED";
})(CameraAccessStatus || (exports.CameraAccessStatus = CameraAccessStatus = {}));
var MessagesType;
(function (MessagesType) {
    MessagesType["TYPE_ACCESS_TOKEN"] = "TYPE_ACCESS_TOKEN";
    MessagesType["TYPE_ACCOUNT_INFO"] = "TYPE_ACCOUNT_INFO";
    MessagesType["TYPE_CHANGE_CONTEXT"] = "TYPE_CHANGE_CONTEXT";
    MessagesType["TYPE_CAMERA_REQUEST"] = "TYPE_CAMERA_REQUEST";
    MessagesType["TYPE_CONTACT"] = "TYPE_CONTACT";
    MessagesType["TYPE_DEVICE_INFO"] = "TYPE_DEVICE_INFO";
    MessagesType["TYPE_FILE_DOWNLOAD"] = "TYPE_FILE_DOWNLOAD";
    MessagesType["TYPE_FILE_SHARE"] = "TYPE_FILE_SHARE";
    MessagesType["TYPE_FINISH"] = "TYPE_FINISH";
    MessagesType["TYPE_FINISH_OTP"] = "TYPE_FINISH_OTP";
    MessagesType["TYPE_GEOLOCATION"] = "TYPE_GEOLOCATION";
    MessagesType["TYPE_GO_BACK"] = "TYPE_GO_BACK";
    MessagesType["TYPE_INIT_OTP"] = "TYPE_INIT_OTP";
    MessagesType["TYPE_INVALIDATE_CACHE"] = "TYPE_INVALIDATE_CACHE";
    MessagesType["TYPE_LANGUAGE"] = "TYPE_LANGUAGE";
    MessagesType["TYPE_OPEN_WEB_BROWSER"] = "TYPE_OPEN_WEB_BROWSER";
    MessagesType["TYPE_PASSWORD_UPDATE"] = "TYPE_PASSWORD_UPDATE";
    MessagesType["TYPE_REFRESH_TOKEN"] = "TYPE_REFRESH_TOKEN";
    MessagesType["TYPE_REFRESH_TOKEN_V2"] = "TYPE_REFRESH_TOKEN_V2";
    MessagesType["TYPE_SEND_OTP_CODE"] = "TYPE_SEND_OTP_CODE";
    MessagesType["TYPE_USER_NAME"] = "TYPE_USER_NAME";
    MessagesType["TYPE_SESSION_TRACKING_INFO"] = "TYPE_SESSION_TRACKING_INFO";
    MessagesType["TYPE_DEVICE_SESSION_DATA"] = "TYPE_DEVICE_SESSION_DATA";
    MessagesType["TYPE_FETCH"] = "TYPE_FETCH";
    MessagesType["TYPE_NATIVE_LOADER"] = "TYPE_NATIVE_LOADER";
})(MessagesType || (exports.MessagesType = MessagesType = {}));
//# sourceMappingURL=types.js.map